import { useCallback } from 'react'
import { useTranslation } from 'libs/i18n'
import { format, parseISO } from 'libs/dates'
import { getDateLocale } from 'shared/components/Datepicker/utils/date'

export const useWeekday = () => {
	const { i18n } = useTranslation()
	const locale = getDateLocale(i18n.language)

	return useCallback((date: string) => format(parseISO(date), 'EEEE', { locale }), [locale])
}
